"use strict";
exports.__esModule = true;
var React = require("react");
var uuid_1 = require("uuid");
var GoogleStreetViewContext_1 = require("../context/GoogleStreetViewContext");
var operation_1 = require("../googlemap/operation");
var googelStreetViewInstance = function (props) {
    var mapId = React.useState(uuid_1.v4())[0];
    var _a = React.useContext(GoogleStreetViewContext_1.GoogleStreetViewContext), map = _a.map, setMap = _a.setMap;
    // SDK Ready
    React.useEffect(function () {
        setMap(operation_1.mapStreetViewCreate(mapId));
    }, []);
    // Map Init
    React.useEffect(function () {
        if (!map)
            return;
        operation_1.mapStreetViewPosition(map, props.center);
    }, [map]);
    // Prop changed
    React.useEffect(function () {
        if (!map)
            return;
        operation_1.mapStreetViewPosition(map, props.center);
    }, [props.center]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { id: mapId, style: { width: '100%', height: '100%' } })));
};
exports.GoogelStreetViewInstance = googelStreetViewInstance;
